import { AiOutlineEdit, AiOutlineDelete } from 'react-icons/ai';
import { IconButton } from '../../../../../../../components/icon-button/icon-button';
import s from './tree-structure-node.module.css';
import { TreeNodeType } from '../../../../../../../store/api/trees-api';
import { forwardRef } from 'react';
import { SimpleTreeItemWrapper, TreeItemComponentProps } from 'dnd-kit-sortable-tree';
import cn from 'classnames';
import { useTreeStructureNode } from './use-tree-structure-node';

export type TreeStructureNodeProps = {
  node: Partial<TreeNodeType>;
};

export const TreeStructureNode = forwardRef<
  HTMLDivElement,
  TreeItemComponentProps<TreeStructureNodeProps>
>((props, ref) => {
  const { handleDeleteNode, handleEdit, isActive, name } = useTreeStructureNode(props.item.node);

  return (
    <SimpleTreeItemWrapper contentClassName={s.feature} {...props} ref={ref}>
      <div className={cn(s.feature, isActive && s.active)}>
        {name}
        <div className={s.controls}>
          <IconButton
            variant="secondary"
            size="sm"
            onClick={handleEdit}
            data-testid={`node-${props.item.node.id}-edit`}
          >
            <AiOutlineEdit />
          </IconButton>
          <IconButton
            variant="secondary"
            size="sm"
            onClick={handleDeleteNode}
            data-testid={`node-${props.item.node.id}-delete`}
          >
            <AiOutlineDelete />
          </IconButton>
        </div>
      </div>
    </SimpleTreeItemWrapper>
  );
});
